import React from "react";
import "./About.css";
import bannerText from "../../Assets/MERN_Stack_Developer.png";
import avatar from "../../Assets/mf-avatar.svg";
import aboutBanner from "../../Assets/about_banner.jpg";

const About = () => {
  return (
    <div
      id="about"
      className="flex lg:flex-row md:flex-row flex-col gap-x-24 gap-y-5 lg:w-[65%] md:w-[85%] mx-auto py-48 lg:px-0 md:px-0 sm:px-8 px-4 mb-6"
    >
      <div className="lg:w-1/2 md:w-1/2 relative">
        <img className="rounded-xl" src={aboutBanner} alt="Office with PC" />
        <div className="bg-white lg:w-44 lg:h-44 w-32 h-32 rounded-full absolute -bottom-14 -right-20 lg:flex justify-center items-center hidden md:hidden">
          <img
            className="lg:w-48 md:w-44 w-36 banner-image"
            src={bannerText}
            alt="MERN Stack Developer"
          />
          <img
            className="lg:w-20 md:w-16 w-14 absolute top-10.5"
            src={avatar}
            alt="avatar"
          />
        </div>
        <div className="bg-white sm:w-32 sm:h-32 w-32 h-32 rounded-full absolute -bottom-14 left-[33%] sm:flex flex justify-center items-center lg:hidden md:hidden">
          <img
            className="lg:w-48 md:w-44 w-36 banner-image"
            src={bannerText}
            alt="MERN Stack Developer"
          />
          <img
            className="lg:w-20 md:w-16 w-14 absolute top-10.5"
            src={avatar}
            alt="avatar"
          />
        </div>
      </div>
      <div className="lg:w-1/2 md:w-1/2 flex flex-col justify-between lg:gap-y-0 md:gap-y-0 gap-y-2 lg:mt-0 md:mt-0 mt-8">
        <h4 className="text-blue tex-lg font-poppins font-bold">ABOUT ME</h4>
        <h2 className="font-poppins font-bold lg:text-xl md:text-xl">
          A dedicated Full-Stack Developer based in React, Next.js, Node.js 📍
        </h2>
        <p className="font-mulish text-gray-light lg:text-base md:text-base text-sm lg:text-start md:text-start text-justify">
          {/* I am an enthusiastic Full-Stack Web Developer with a strong passion
          for creating full-stack web applications. With a solid background in
          JavaScript, TypeScript, React, Redux, Next.js, Node.js, Express.js and
          MongoDB. I have expertise in building high-performance, scalable, and
          responsive applications. I'm committed to delivering high-quality,
          user-friendly applications. My goal is to stay up-to-date with
          industry standards and best practices to provide optimal solutions
          that exceed expectations. */}
          I am an enthusiastic{" "}
          <span className="font-semibold">Full-Stack Web Developer</span>{" "}
          passionate about building scalable, high-performance web applications.
          I work with{" "}
          <span className="font-semibold">
            JavaScript, TypeScript, React, Redux, Next.js, Node.js, Express.js ,
            and MongoDB{" "}
          </span>
          to create responsive and user-friendly solutions. I am currently a{" "}
          <span className="font-semibold">
            Control Systems & Computer Engineering
          </span>{" "}
          student at{" "}
          <span className="font-semibold">Moscow Aviation Institute (MAI)</span>
          , one of Russia’s top national research universities, and I
          continuously strive to follow industry best practices to deliver
          high-quality results.
        </p>
      </div>
    </div>
  );
};

export default About;
